import React from "react";
import {
  Grid,
  Typography,
} from "@material-ui/core";
import { formatDate } from "@icarius-utils/date";
import StepContainer from "./stepContainer";
import ChangeStatusInput from "../changeStatusInput";
import { getLocalizedString } from "@icarius-localization/strings";

const StepFour = (props) => {

  const {
    isCreate,
    data,
    formData,
    setFormValue,
    statusList,
  } = props;

  return (
    <StepContainer title={getLocalizedString("evaluationStepsAndStages")}>
      <Grid
        container item alignItems="center" xs={12}
        style={{ marginTop: 10, marginBottom: 10, background: 'var(--secondaryBackgroundColor)', borderRadius: 4 }}
        className='myDesktopShadow'
      >
        <div style={{ padding: 15, display: 'flex', flexWrap: 'wrap', rowGap: 10, columnGap: 40 }}>
          <div>
            <Typography className="whiteText" variant="caption">{getLocalizedString("dateFrom")}</Typography>
            <Typography className="whiteText">{formatDate(formData.evaluationStartDate)}</Typography>
          </div>
          <div>
            <Typography className="whiteText" variant="caption">{getLocalizedString("dateEnd")}</Typography>
            <Typography className="whiteText">{formatDate(formData.evaluationEndDate)}</Typography>
          </div>
          <div>
            <Typography className="whiteText" variant="caption">{getLocalizedString("createdFemale")}</Typography>
            <Typography className="whiteText">{isCreate ? formatDate(new Date()) : data.creationDate}</Typography>
          </div>
        </div>
      </Grid>
      <ChangeStatusInput
        data={data}
        formData={formData}
        setFormValue={setFormValue}
        statusList={statusList}
      />
    </StepContainer>
  );
}

export default StepFour;